import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { from, fromEvent, interval, debounce, delay, mergeMap, tap, throttleTime } from 'rxjs';

@Component({
    selector: 'ea-env-border',
    templateUrl: './ea-env-border.component.html',
    styleUrls: ['./ea-env-border.component.scss'],
    standalone: false
})
export class EaEnvBorderComponent implements OnInit, OnDestroy {
  integEnvColor = '#E37700';
  preprodEnvColor = '#0D9E5D';
  recetteEnvColor = '#1A56B0';
  environment = environment;
  hide = false;
  alive = true;

  constructor() {
    if (!this.show) return;
    from(['mousemove', 'touchstart', 'touchmove'])
      .pipe(
        mergeMap(e => fromEvent(document, e)),
        delay(500),
        throttleTime(1000),
        tap(() => (this.hide = true)),
        debounce(() => interval(5000)),
      )
      .subscribe(e => {
        this.hide = false;
      });
  }

  ngOnInit() {}

  get show() {
    return ['integration', 'preprod', 'recette'].includes(
      environment.target.toLowerCase(),
    );
  }

  get envColor() {
    switch (environment.target.toLowerCase()) {
      case 'integration':
        return this.integEnvColor;
      case 'recette':
        return this.recetteEnvColor;
      default:
        return this.preprodEnvColor;
    }
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
